module.exports = __webpack_public_path__ + "img/ticketW.5be53957.svg";